module.exports = __webpack_public_path__ + "img/print-logo.edcceb45.png";